<app-error-page *ngIf="showError" (buttonClicked)="goToLoginPage()"></app-error-page> 
